import { Box, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  padding: '15px 10px 15px 5px',
}));

export const InnerContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}));

export const ConditionalDivider = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3px 0 4px',
  background: 'rgba(201, 255, 235, 1)',
  color: 'rgba(1, 128, 148, 1)',
  fontSize: '16px',
  lineHeight: '21px',
  borderRadius: '6px',
  fontWeight: 600,
}));

export const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
  },
}));

export const AddButton = styled(Box)(({ theme }) => ({
  flex: '1 1 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
  padding: '4px 5px',
  borderRadius: '6px',
  border: '1px solid rgba(221, 221, 234, 1)',
  background: 'white',
  cursor: 'pointer',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',

  '.MuiTypography-root': {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20.8px',
  },

  '&:hover': {
    borderColor: 'rgba(30, 237, 159, 1)',
  },

  '&:active': {
    borderColor: 'rgba(30, 217, 147, 1)',

    '.MuiSvgIcon-root': {
      color: 'rgba(34, 40, 34, 1)',
    },
  },

  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'wrap',
  },
}));

export const TitleContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '5px',

  '.MuiTypography-body1': {
    fontSize: '16px',
    lineHeight: '20.8px',
    fontWeight: 600,
  },
}));

export const Input = styled(TextField)(() => ({
  '.MuiInputBase-input': {
    padding: '5.5px 10px',
    fontWeight: 600,

    '&::placeholder': {
      fontWeight: 400,
    },

    '&:placeholder-shown': {
      textOverflow: 'ellipsis',
    },
  },

  fieldset: {
    top: 0,
  },
}));

export const GroupWrapper = styled(Box)(() => ({
  padding: '7px 10px 10px',
  background: 'rgba(239, 239, 244, 1)',
  borderRadius: '6px',
}));

export const RuleBg = styled(Box)(() => ({
  padding: '7px 10px 10px',
  marginBottom: '10px',
  background: 'white',
  borderRadius: '6px',
}));
